import React from "react";
import Modal from "components/Modals/Modal";
import CloseButton from "components/Buttons/CloseButton";
import Button from "../../components/Buttons/Button";
import MarkdownContent from "../../components/Markdown";
import "./MobileModal.scss";

interface MobileModalProps {
    title?: string;
    description: string;
    buttonText: string;
    buttonTarget: string;
    onClose(): void;
}

const MobileModal: React.FC<MobileModalProps> = ({
    title,
    description,
    buttonText,
    buttonTarget,
    onClose,
}) => {
    return (
        <Modal isVisible classes={{ container: "mobile-modal" }}>
            <div className={"mobile-modal__header"}>
                <div className={"mobile-modal__header__title"}>{title}</div>
                <CloseButton
                    className={"mobile-modal__header__close-button"}
                    handleClose={onClose}
                />
            </div>
            <div className={"mobile-modal__body"}>
                <MarkdownContent
                    content={description}
                    className={"mobile-modal__body__description"}
                />
            </div>
            <div className={"mobile-modal__footer"}>
                <Button
                    size="small"
                    variant="secondary"
                    className={"mobile-modal__footer__button"}
                    to={buttonTarget}
                    text={buttonText}
                />
            </div>
        </Modal>
    );
};

export default MobileModal;
